// skeleton cards will not need to be updated or rerendered, ok to use index
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as R from 'ramda';

// Components
import AuthSequencingCardSkeleton from './AuthSequencingCardSkeleton';
import CardSkeleton from './CardSkeleton';
import CarrierAuthorizationCardSkeleton from './CarrierAuthorizationCardSkeleton';
import SupplierAuthCardSkeleton from './SupplierAuthCardSkeleton';
import MyAuthorizationCardSkeleton from './MyAuthorizationCardSkeleton';

// utils
import { CARD_WIDTH } from '../../../utils/constants';

const CardSkeletonList = ({ numberOfCards: initialNumberOfCards }) => {
  const container = useRef();
  const [numberOfCards, setNumberOfCards] = useState(initialNumberOfCards || 0);
  const xsDown = useMediaQuery(theme => theme.breakpoints.down('xs'), { noSsr: true });
  const { viewBy } = useParams();
  const { pathname } = useLocation();
  const authorizationType = pathname.split('/')[5];

  // the number of cards is set based on the size of the window when initially rendered
  useEffect(() => {
    if (xsDown) {
      setNumberOfCards(1);
    } else {
      const totalWidth = CARD_WIDTH + 2 * 16;
      const containerWidth = container.current ? container.current.clientWidth : 0;
      if (!initialNumberOfCards) {
        setNumberOfCards(Math.floor(containerWidth / totalWidth));
      }
    }
  }, [xsDown, initialNumberOfCards]);

  const generateSkeleton = () =>
    R.cond([
      [R.equals('supplier-authorizations'), () => <SupplierAuthCardSkeleton />],
      [R.equals('self-authorizations'), () => <CardSkeleton />],
      [R.equals('authorization-sequencing'), () => <AuthSequencingCardSkeleton />],
      [R.equals('my-authorizations'), () => <MyAuthorizationCardSkeleton />],
      [
        R.equals('carrier-authorizations'),
        () => <CarrierAuthorizationCardSkeleton viewBy={viewBy} />,
      ],
    ])(authorizationType);
  const skeletonArray = numberOfCards ? Array(numberOfCards).fill(() => generateSkeleton()) : [];

  return (
    <Box
      data-testid="skeletons"
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      justifyContent={xsDown ? 'center' : 'flex-start'}
      ref={container}
      width="100%"
    >
      {skeletonArray.map((Component, index) => (
        <Component key={`SkeletonCard${index}`} />
      ))}
    </Box>
  );
};

CardSkeletonList.propTypes = {
  numberOfCards: PropTypes.number,
};

CardSkeletonList.defaultProps = {
  numberOfCards: 0,
};

export default CardSkeletonList;
